import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useMutation } from "graphql-hooks";
import {
  Card,
  CardContent,
  Container,
  Typography,
  Button,
  Grid,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import checkImg from "./assets/Check.png";
import mascotJoin from "./assets/login-mascot.png";
import useIsTablet from "./hooks/useIsTablet";
import useIsMobile from "./hooks/useIsMobile";

import { ACTIVATE_USER_MUTATION } from "./graphQL/user_qry";

const StyledContainer = styled(Container)(() => ({
    width: "548px",
    "@media (max-width: 856px)":  { width: "393px" },
    paddingBottom: 80,
    paddingTop: 40,    
    minHeight: 268,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

}));

const StyledCardContent = styled(CardContent)(() => ({
    
    padding: 4,
    display: "flex",
    flexDirection: "column",
    minHeight: 200,    
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",

    
}));

const StyledTypography  = styled(Typography)(() => ({
    color: "rgba(33, 33, 33, 0.8)",
    fontSize: "18px",
    fontStyle: "normal",
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
    fontWeight: "400",
    lineHeight: "1.7",
    letterSpacing: "0.00938em",
}));

const StyledButton = styled(Button)(() => ({
    width: "158px",
    height: "48px",
    backgroundColor: "#EF5658",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#EF5658",
    },
    "&:hover": {
      backgroundColor: "#D33338",
    },
}));

const UpdatePasswordConfirmation = () => {
  const navigate = useNavigate(); 

  const isTablet = useIsTablet(1360); // Use 1360px breakpoint for tablet size
  const isMobile = useIsMobile(856); // Use 856px breakpoint for mobile size

  useEffect(() => {
    window.scrollTo(0, 0);    
  }, []); 

  return (
<Grid>
        <>
          <Helmet>
            <title>R3PLAY | Update Password Successful</title>
            <meta
              name="description"
              content="Confirm your signup code to activate your account and start trading toys"
            />
            <meta
              property="keywords"
              content="Account activation, email verification, toy trading account"
            />        
          </Helmet>

          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Box sx={{ position: "relative", display: "inline-block" }}>

             
              <StyledContainer>
                <Card style={{ display: "flex", flexDirection: "row", position: "relative", zIndex: 2, }}>
                  <StyledCardContent  style={{ margin:"15px" }}>
                    <Box alignItems="center" mb={3} flexGrow={1}>
                      <Box>
                          <img src={checkImg} alt="logo" width="173" />
                      </Box>
                        <br />
                      <Typography gutterBottom 
                          variant={isMobile ? "h4" : "h3"}
                          fontSize={isMobile ? "24px" : "32px"}
                          sx={{                          
                          GutterBottom: "False",                          
                          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                          fontWeight: "600",
                          lineHeight: "1.75",
                          marginBottom: "25px",
                          letterSpacing: "0.00938em"
                        }}>
                          Password Reset Successful!
                      </Typography>

                      <StyledTypography variant="body1">
                         Your password has been reset successfully. 
                         You can now log in with your new password.
                      </StyledTypography>
                      <br />
                      <StyledButton
                            color="primary"
                            type="submit"
                            variant="contained"
                            onClick={() => navigate("/signin")}
                            >
                            GO TO SIGN IN
                      </StyledButton>

                    </Box>
                 </StyledCardContent> 
                </Card>
              </StyledContainer>

             {!isMobile && (
                    <Box
                    component="img"
                    src={mascotJoin}
                    alt="Mascot"
                    sx={{
                      position: "absolute",
                      bottom: "40px",  
                      right: "-128px",   
                      width: 150,
                      height: "auto",
                      zIndex: 1, 
                      opacity: 0.9,  
                    }}
                  />
                )}
              </Box>
            </Box>
        </>
    </Grid>
  );
};

export default UpdatePasswordConfirmation;
